import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Search from './components/Search';
import ContactUs from './components/ContactUs';
import About from './components/About';
const PincodeSearch = React.lazy(() => import('./components/PincodeSearch'));

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="App-main">
          <Routes>
            <Route path="/" element={<Search />} />
            <Route path="/pincode" element={
              <Suspense fallback={<div style={{padding:20}}>Loading pincode page…</div>}>
                <PincodeSearch />
              </Suspense>
            } />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
